export default {
  intelligentOfficialDoc_my_test: '我的測試',
  intelligentOfficialDoc_practice: '練習',
  intelligentOfficialDoc_self_assessment: '自評',
  intelligentOfficialDoc_test: '測試',
  intelligentOfficialDoc_total: '全部',
  intelligentOfficialDoc_level01: '大神，請收下我的膝蓋',
  intelligentOfficialDoc_level02: '大神，請收下我的膝蓋',
  intelligentOfficialDoc_level03: '百煉始成鋼，相信自己會做的更好',
  intelligentOfficialDoc_level04: '開掛的人生，從不畏懼失敗',
  intelligentOfficialDoc_level05: '開掛的人生，從不畏懼失敗',
  intelligentOfficialDoc_ranking: '當前排名：第{rank}名',
  intelligentOfficialDoc_rank_percent: '已超過{rankPercent}%的小夥伴',
  intelligentOfficialDoc_check_resolution: '查看解析',
  intelligentOfficialDoc_practice_num_score: '已累計訓練{practiceNum}次，最高得分{topScore}分',
  intelligentOfficialDoc_practice_notes: '查看練習記錄',
  intelligentOfficialDoc_start_practicing: '開始練習',
  intelligentOfficialDoc_intelligent_writing: '智能公文寫作',
  intelligentOfficialDoc_AI_reviewing: 'AI智能評審中，請等待…',
  intelligentOfficialDoc_exit_check_list: '您可先行退出，評審完成後進入任務列表查看結果',
  intelligentOfficialDoc_review_progress: '評審進度',
  intelligentOfficialDoc_positive_completion_time: '按完成時間正序排列',
  intelligentOfficialDoc_reverse_completion_time: '按完成時間倒序排列',
  intelligentOfficialDoc_order_number: '序號',
  intelligentOfficialDoc_title_name: '名稱',
  intelligentOfficialDoc_type: '類型',
  intelligentOfficialDoc_completed_time: '完成時間',
  intelligentOfficialDoc_operation: '操作',
  intelligentOfficialDoc_achievement: '成績',
  intelligentOfficialDoc_task_type: '任務類型',
  intelligentOfficialDoc_sort_order: '排序方式',
  intelligentOfficialDoc_enter_title: '請輸入名稱',
  intelligentOfficialDoc_check_detail: '查看詳情',
  intelligentOfficialDoc_waiting_review: '等待評審',
  intelligentOfficialDoc_no_permission: '暫無權限',
  intelligent_files: '我的智能公文',
  intelligentOfficialDoc_no_subject: '暫無題目',
  intelligentOfficialDoc_result_report: '成績報告',
  intelligentOfficialDoc_spacie_indent: '行距縮進',
  intelligentOfficialDoc_title_end: '標題結尾',
  intelligentOfficialDoc_hierarchy_label: '層次標號',
  intelligentOfficialDoc_conference_presentation: '會議表述',
  intelligentOfficialDoc_meeting_elements: '會議要素',
  intelligentOfficialDoc_Background_objective: '背景目標',
  intelligentOfficialDoc_core_consensus: '核心共識',
  intelligentOfficialDoc_action_plan: '行動計劃',
  intelligentOfficialDoc_overall_structure: '整體結構',
  intelligentOfficialDoc_paragraph_structure: '段落結構',
  intelligentOfficialDoc_hierarchical_structure: '層次結構',
  intelligentOfficialDoc_concise_language: '語言精練',
  intelligentOfficialDoc_limit_word_num: '字數限製',
  intelligentOfficialDoc_statement_specification: '語句規範',
  intelligentOfficialDoc_punctuation_words: '字詞標點',
  intelligentOfficialDoc_issue_number: "出現{number}處問題",
  intelligentOfficialDoc_review_Report: '《{topicTitle}》會議紀要寫作智能評審報告',
  intelligentOfficialDoc_actual_time: '實際用時：{timeLimit}分鐘',
  intelligentOfficialDoc_completion_time: '完成時間：{doneDate}',
  intelligentOfficialDoc_total_scores: '{testType}總得分',
  intelligentOfficialDoc_cur_rank: '當前排名:',
  intelligentOfficialDoc_rank:'排名',
  intelligentOfficialDoc_total_num: '當前參與測試總人數：{total}人',
  intelligentOfficialDoc_format_style: '格式體例',
  intelligentOfficialDoc_idea_content: '思想內容',
  intelligentOfficialDoc_logical_structure:'邏輯結構',
  intelligentOfficialDoc_linguistic_performance:'語言運用',
  intelligentOfficialDoc_format_score:'格式體例({noSelf}分)',
  intelligentOfficialDoc_idea_content_score:'思想內容(30分)',
  intelligentOfficialDoc_logical_score:'邏輯結構({noSelf}分)',
  intelligentOfficialDoc_linguistic_score:'語言運用({noSelf}分)',
  intelligentOfficialDoc_check_detail:'下拉查看評審詳情',
  intelligentOfficialDoc_accurate_analysis:'精準分析',
  intelligentOfficialDoc_reference_model:'參考範文',
  intelligentOfficialDoc_keep_practicing:'繼續練習',
  intelligentOfficialDoc_Illegal_character:'{msg}存在非法字符，無法正確標註',
  intelligentOfficialDoc_review_details:'評審詳情',
  intelligentOfficialDoc_total_qus_comment:'整體問題批註：',
  intelligentOfficialDoc_specific_qus_comment:'具體問題批註：',
  intelligentOfficialDoc_check_require:'查看原寫作素材和要求',
  intelligentOfficialDoc_practice_improve:'練習提高',
  intelligentOfficialDoc_collapse_page:'收起頁面',
  intelligentOfficialDoc_to_be_reviewed:'待評審',
  intelligentOfficialDoc_expired:'已過期',
  intelligentOfficialDoc_check_results:'查看成績',
  intelligentOfficialDoc_Status_start:'開始',
  intelligentOfficialDoc_Status_goon:'繼續',
  intelligentOfficialDoc_pra_commend:'練習/自評',
  intelligentOfficialDoc_welcome_tip:'歡迎來到智能公文寫作練習/自評，請完成以下練習或自評，練習/自評完成後我們會通過對您的寫作內容進行智能分析來給出結果報告，並以科學的數據可視化方式來展示結果報告。',
  intelligentOfficialDoc_positive_end_time:"按截止時間倒序排列",
  intelligentOfficialDoc_reverse_end_time:"按截止時間正序排列",
  intelligentOfficialDoc_welcome_tip_txt:" 歡迎來到智能公文寫作測試，請完成以下測評，測評完成後我們會通過對您的考試內容進行智能分析來給出結果報告，並以科學的數據可視化方式來展示結果報告。",
  intelligentOfficialDoc_get_time:'{hours}小時{minutes}分鐘{seconds}秒',
  intelligentOfficialDoc_should_know:'{typeText}須知',
  intelligentOfficialDoc_title_label:'名稱：',
  intelligentOfficialDoc_duration:'時長：',
  intelligentOfficialDoc_points_attention:'註意事項：',
  intelligentOfficialDoc_answer_rules01:'1.	開始答題後，請認真閱讀答題說明，按要求答題；',
  intelligentOfficialDoc_answer_rules02:'2.	如遇網速較慢，文字、圖片不能顯示或系統出現意外（網絡連接中斷、機器故障），請退出答題，稍後或更換網絡環境後重新登錄，繼續作答；最多只可退出10次；',
  intelligentOfficialDoc_answer_rules03:'3.	考試倒計時結束後，系統將自動交卷；',
  intelligentOfficialDoc_answer_rules04:'4.	不得以任何形式傳播試題內容；系統將全程監控答題過程中截屏、抄錄、復製等行為；',
  intelligentOfficialDoc_answer_rules05:'5.	系統對作弊行為自動識別，如被認定為作弊，考試成績失效。',
  intelligentOfficialDoc_answer_rules1:'1.	自評模式下，無給定材料和時間限製。開始答題後，請根據作答要求答題。',
  intelligentOfficialDoc_answer_rules2:'2.	如遇網速較慢，文字、圖片不能顯示或系統出現意外（網絡連接中斷、機器故障），請關閉作答窗口，稍後或更換網絡環境後重新登錄，繼續作答。',
  intelligentOfficialDoc_enter_in:'進入',
  intelligentOfficialDoc_request_timeout:'請求超時',
  intelligentOfficialDoc_full_screen_tip:'請確認開啟全屏寫作？',
  intelligentOfficialDoc_exit_dialog:'你已退出10次，5秒後將自動提交',
  intelligentOfficialDoc_end_dialog:'測試時間結束，5秒後將自動提交',
  intelligentOfficialDoc_submit_time:'提交（{autoSubmitTime}）',
  intelligentOfficialDoc_exit_one_time:'你剛剛退出了1次',
  intelligentOfficialDoc_exit_num01:'退出全屏計為退出1次，{warningTxt}',
  intelligentOfficialDoc_exit_num02:'你已第{opportunity}次退出，退出{OPPORTUNITY}次將自動提交。',
  intelligentOfficialDoc_keep_writing:'繼續寫作',
  intelligentOfficialDoc_confirm_exit:'是否確認退出',
  intelligentOfficialDoc_exit_screen01:'退出後將暫停計時、自動保存已作答內容，{warningTxt}',
  intelligentOfficialDoc_exit_screen02:"你已退出{opportunity}次，最多只可退出{OPPORTUNITY}次",
  intelligentOfficialDoc_temporary_exit:'暫時退出',
  intelligentOfficialDoc_confirm_submit:'是否提交內容',
  intelligentOfficialDoc_exit_ten_time:'最多只可退出10次，你已退出了10次，繼續退出將提交內容',
  intelligentOfficialDoc_submit_content:"提交內容",
  intelligentOfficialDoc_give_material:"給定材料：",
  intelligentOfficialDoc_answer_rules:'作答要求：',
  intelligentOfficialDoc_nothing:'無',
  intelligentOfficialDoc_Entered:"已輸入{richTextNum}字",
  intelligentOfficialDoc_submit:'提交',
  intelligentOfficialDoc_check_content:'提交前記得認真檢查內容',
  intelligentOfficialDoc_confirm_submission:'確認提交',
  intelligentOfficialDoc_writing_exercise:'通知書寫練習',
  intelligentOfficialDoc_no_discover_ques:'未出現問題',
  intelligentOfficialDoc_countdown:"倒計時：",
  intelligentOfficialDoc_scoreList:'{scoreList}分',
  intelligentOfficialDoc_get_timeNew:'{hours}時{minutes}分{seconds}秒',
  intelligentOfficialDoc_get_noHoursTime: '{minutes}分{seconds}秒',
  finshed_time: '已獲學時：'
}
